var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.825,
    height: 114.897,
    viewBox: "0 0 104.825 114.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16212",
    "data-name": "Path 16212",
    d: "M175.479,33.6c-13.535,0-23.905,13.228-23.905,28.985s10.371,28.985,23.905,28.985,23.946-13.229,23.946-28.985S189.015,33.6,175.479,33.6ZM165.2,94.092c-19.613,2.56-35.461,11.445-39.108,24.14a2.531,2.531,0,0,0,0,1.378c2.16,7.518,8.745,13.67,17.644,18s20.244,6.892,32.65,6.892,23.79-2.565,32.688-6.892,15.484-10.48,17.644-18a2.531,2.531,0,0,0,0-1.378c-3.647-12.7-19.493-21.581-39.108-24.14a2.566,2.566,0,0,0-2.206.827l-9.019,10.318L167.4,94.919a2.566,2.566,0,0,0-2.206-.827Zm30.01,16.7h5.041v7.562h7.562v5.04h-7.562v7.562H195.21v-7.562h-7.561v-5.04h7.561Z",
    transform: "translate(-123.991 -31.602)",
    fill: "none",
    stroke: "#2c53bb",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetCare);
export default __webpack_public_path__ + "static/media/get-care.60ec5a3a15b1ec60858e2f7e5e2340a7.svg";
export { ForwardRef as ReactComponent };